<template>
  <div>
    <div :class="$q.screen.gt.sm ? 'row' : 'column'" class="justify-between q-pt-lg q-pb-md"
         style="width:88%;margin:auto;">
      <span class="title-header col text-highlight text-weight-bold text-center q-ma-none"
            :style="$q.screen.gt.sm ? 'font-size:22px;' : 'font-size:20px;'">{{ $metaInfo.title }}</span>
      <div :class="$q.screen.gt.sm ? 'float-right' : 'justify-end'" class="row">
        <v-button v-show="!isActiveToolbar('filter')"
                  flat round dense no-caps color="primary"
                  icon="fa icon-search-sm"
                  @click="toggleToolbar('filter', $event)">
        </v-button>
        <q-input
            hide-underline
            autofocus
            v-if="isActiveToolbar('filter')"
            v-model="tempFilter"
            color="primary"
            class="bg-search"
            :placeholder="$T('search')"
            :before="[{icon: 'fa icon-search-sm', handler () { toggleToolbar('filter') }}]"
            @input="updateFilter"
        />
        <v-button v-show="!isActiveToolbar('columns')"
                  flat round dense no-caps color="primary"
                  icon="fa icon-filter"
                  @click="toggleToolbar('columns', $event)">
        </v-button>
        <select-extended v-show="isActiveToolbar('columns')"
                         select-all multiple toggle hide-underline
                         class="capitalize"
                         v-model="visibleColumns"
                         :options="columnsOptions"
                         :display-value="$T('filter')"
                         @focus="selectOpen = true"
                         :before="[{icon: 'fa icon-filter', handler () {toggleToolbar('columns') }}]"/>
        <v-button v-if="exportRoute"
                  flat round dense no-caps color="primary"
                  icon="cloud download"
                  @click="$router.push({ name: exportRoute })">
          <q-tooltip anchor="top left" self="bottom middle">
            {{ $T('export') }}
          </q-tooltip>
        </v-button>
        <v-button v-if="directExportRoute"
                  flat round dense no-caps color="primary"
                  icon="cloud download"
                  @click="openURL(directExportRoute)">
          <q-tooltip anchor="top left" self="bottom middle">
            {{ $T('export') }}
          </q-tooltip>
        </v-button>

        <v-button v-if="reverseFlowRoute"
                  flat round dense no-caps color="primary"
                  icon="calendar_view_day"
                  @click="openURL(reverseFlowRoute)">
          <q-tooltip anchor="top left" self="bottom middle">
            {{ $T('reverse flow') }}
          </q-tooltip>
        </v-button>

      </div>
    </div>

    <div v-if="showTabs" :class="$q.screen.gt.sm ? 'tabs-desktop q-mb-md' : 'tabs-mobile q-mb-sm'">
      <q-tabs
          :class="isCurrentRoute('lending-point.lending-kits') || isCurrentRoute('sales-expert.lending-kits') ? 'tabs-in-table-special' : 'tabs-in-table'"
          class="full-width"
          inverted
          two-lines
          v-model="tab"
      >
        <q-tab
            default
            :color="colorTabAll"
            :class="$q.screen.gt.sm ? 'row col' : 'column'"
            class="capitalize text-weight-bold"
            slot="title"
            name="tab-all"
            icon="fa icon-globe"
            :label="$T('all')"
            @click="applyFilter('all')"
            ref="all"/>
        <q-tab
            v-for="(filter,key) in tabFilters"
            :key="`tab-${key}`"
            :color="colorTab"
            :class="$q.screen.gt.sm ? 'col' : ''"
            class="capitalize text-weight-bold"
            slot="title"
            :name="`tab-${filter}`"
            :label="filter"
            @click="applyFilter(key)"
            :ref="filter"
            :icon="iconsTabs.hasOwnProperty(key.toLowerCase()) ? iconsTabs[key.toLowerCase()] : ''"/>
      </q-tabs>
    </div>

    <div v-if="$q.screen.gt.sm">
      <q-table class="shadow-25 v-list bg-hard-white"
               :style="$q.screen.gt.md ? 'margin-left:calc(48% + 60px);transform: translateX(-50%);' : 'margin:auto;'"
               style="width:88%;"
               :loading="isLoading"
               @request="refreshRows"
               :data.sync="results.data"
               :hide-header="false"
               :columns="columnsAvailable"
               :filter="filter"
               :visible-columns="visibleColumns"
               row-key="id"
               :pagination.sync="pagination"
      >
        <q-tr v-if="rowClick" :slot="rowClick ? 'body' : ''" slot-scope="props" :props="props"
              @click.native="rowClick(props.row)" class="cursor-pointer table-row">
          <q-td v-for="col in props.cols" :props="props" :key="col.name"
                :style="highlightRow(props) ? 'color: #E3813B; font-weight: bold;' : ''">
                        <span v-if="col.name === 'order_status.description'" class="text-subtitle1">
                            {{ col.value }}
                        </span>
            <span v-else-if="col.name === 'followup_status'" class="text-subtitle1">
                            {{ followupStatuses[props.row.id] || '...' }}
                        </span>
            <span v-else-if="col.name === 'stock_status.description'" class="text-subtitle1">
                            {{ col.value }}
                        </span>
            <v-button v-else-if="col.name === 'stock_actions'"
                      :disable="isLoading || (!props.row.stock_broken_count && !props.row.stock_retired_count)"
                      :color="isLoading || (!props.row.stock_broken_count && !props.row.stock_retired_count) ? 'grey' : 'green'"
                      class="on-right"
                      icon="local_shipping"
                      size="sm" round dense>
              <q-tooltip anchor="top left" self="bottom middle">
                {{ $T('pick up stock') }}
              </q-tooltip>
              <q-popover v-if="props.row.stock_broken_count || props.row.stock_retired_count">
                <div class="group text-center">
                  <p><strong>{{ $T('are you sure?') }}</strong></p>
                  <v-button class="no-shadow capitalize" color="negative" no-caps
                            @click="pickUpStock(props.row.id)" v-close-overlay>
                    {{ $t('yes') }}
                  </v-button>
                </div>
              </q-popover>
            </v-button>
            <div v-else-if="col.name === 'end_lending_at' && highlightRow(props)"
                 class="row items-center justify-end no-wrap">
              <div>{{ col.value }}</div>
              <q-btn size="sm" round flat icon="fa icon-warning" class="q-ml-sm" @click.native="orderWarningButton">
                <q-popover id="warning-pop">
                  <div class="group text-center warning-text">
                    <p>{{ $T('This lending expired') }} <strong
                        style="color: #E3813B;">{{ calculateLendingExpiredDays(props) }}</strong>.</p>
                    <p>{{ $T('The kit returned and you want close the order?') }}</p>
                    <div class="row justify-center">
                      <router-link tag="a" to="orders/in-lending">
                        {{ $T('Go to close lending') }}
                        <q-icon class="q-ml-sm" name="fa icon-chevron-secondary-right"></q-icon>
                      </router-link>
                    </div>
                  </div>
                </q-popover>
              </q-btn>
            </div>
            <template v-else>{{ col.value }}</template>
            <q-icon
                name="fa icon-edit"
                class="cursor-pointer"
                v-if="col.name === '-actions' && enableEdit(props) && !props.row['extended_at']"
                @click.native="editRow(props, $event)">
            </q-icon>
            <v-button
                :no-caps="true"
                :label="$t('confirm delivery')"
                v-if="col.name === '-actions' && isCurrentRoute('lending-point.lending-kits.pending-reception')"
            />
            <v-button
                :no-caps="true"
                :label="$t('sanitize the kit')"
                v-if="col.name === '-actions' && (isCurrentRoute('sales-expert.clear') || isCurrentRoute('lending-point.clear'))"
            />
            <v-button
                :no-caps="true"
                :label="$t('close lending')"
                v-if="col.name === '-actions' && (isCurrentRoute('lending-point.orders.in-lending') || isCurrentRoute('sales-expert.orders.in-lending'))"
            />
          </q-td>
        </q-tr>
        <q-td slot="body-cell-order_status.description" slot-scope="props" :props="props">
          {{ props.value }}
        </q-td>
      </q-table>
    </div>
    <div v-else>
      <Collapsible
          :label="collapsibleLabel"
          :subLabel="collapsibleSubLabel"
          :contentItems="results.data"
          :columnsCollapsible="columnsAvailable"
          :visibleColumns="visibleColumns"
          @isModalOpen="isModalOpen($event)"
          @collapsibleRowEdit="collapsibleRowEdit"
      />
    </div>

    <div :class="$q.screen.gt.sm ? 'justify-end styled-pagination q-mt-lg' : 'justify-center q-mt-md q-mb-lg'"
         class="row pag-row">
      <q-chip class="bg-hard-white shadow-4">
        <q-pagination
            ref="pagination"
            v-model="page"
            color="primary"
            :max="results.meta.last_page"
            :max-pages="4"
            :ellipses="true"
            direction-links
        />
      </q-chip>
    </div>

    <q-modal v-model="modalEndDate" no-backdrop-dismiss no-esc-dismiss id="modalEndDateMobile">
      <div>
        <div class="text-weight-bold" slot="title">
          <div class="row justify-end">
            <q-icon name="fa icon-close cursor-pointer" @click.native="closeDialog"/>
          </div>
          <div class="column items-center text-center font-title-modalEndDate"
               :class="isMobile ? '' : 'dialog-padding'">
            {{ form ? $t('¿Seguro que desea extender el préstamo') + ' ' + form.id + ' ?' : $t('¿Seguro que desea extender el préstamo?') }}
            <hr class="q-mt-sm q-mb-xl modal-hr" width="100%">
          </div>
        </div>

        <card width="100%" style="background:#FFFFFF!important;">
          <form class="row gutter-xs" @keydown="form.onKeydown($event)">

            <!--<v-datetime path="end_lending_at"
                        v-model="form.end_lending_at"
                        :label="$t('lending end date')"
                        format-data="YYYY-MM-DD"
                        format="DD-MM-YYYY"
                        :form="form"
                        class="col-12">
            </v-datetime>-->

            <!-- Submit Button -->
            <div :class="isMobile ? 'column reverse q-mt-xl col-8' : 'row q-mt-md col-12'" class="justify-center group"
                 :style="isMobile ? 'margin-left:auto;margin-right:auto;' : ''">

              <!-- Cancel -->
              <v-button outline
                        no-caps
                        rounded
                        :label="$T('cancel')"
                        color="primary"
                        class="no-shadow q-btn-iqos"
                        @click.prevent="cancelEndDate">
              </v-button>

              <!-- Save changes -->
              <v-button :label="$T('extender')"
                        id="btn-save-edit-modal"
                        no-caps
                        text-color="primary"
                        rounded
                        color="highlight"
                        class="no-shadow q-btn-iqos"
                        :loading="form.busy"
                        :disable="form.busy"
                        @click.prevent="save">
                <template slot="loading">
                  <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                  {{ $T('saving...') | capitalize }}
                </template>
              </v-button>
            </div>
          </form>
        </card>
      </div>
    </q-modal>

    <q-dialog
        v-model="customDialog"
        prevent-close>
                <span class="text-weight-bold" slot="title">
                        <div class="row justify-end">
                            <q-icon name="fa icon-close cursor-pointer" @click.native="customDialog = false"/>
                        </div>
                        <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                            {{ customDialogMessage }}
                            <hr class="q-mt-sm q-mb-xl modal-hr" width="100%">
                        </div>
                </span>

      <template slot="buttons" slot-scope="props">
        <div
            :class="isMobile ? 'column reverse half-width justify-between' : 'row full-width justify-around q-mb-lg dialog-padding'"
            class="items-center">
          <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" no-caps color="highlight"
                 text-color="primary" rounded :label="$t('close')" @click="customDialog = false"/>
        </div>
      </template>
    </q-dialog>
  </div>
</template>

<script>
import {
  openURL,
  debounce,
  QTable,
  QTr,
  QTd,
  QInput,
  QToggle,
  QPopover,
  QChip,
  QTooltip
} from 'quasar-framework'
import axios from 'axios'
import {userPreferences} from '../store/modules/userPreferences'
import {mapGetters} from 'vuex'
import Collapsible from '../components/Collapsible.vue'
import iconsTabs from "./iconsTabs"
import moment from "moment";
import Form from 'vform'
import orderModel from './orderModel'
import VButton from "../components/form/VButton";

const PER_PAGE = 10

const PAGINATION_QUANTITIES = [10, 20, 50, 100]

export default {
  metaInfo() {
    return {title: (this.isLoading ? this.$T('loading') + ' ' : '') + this.plural}
  },

  mixins: [iconsTabs, orderModel],

  components: {
    VButton,
    QTable,
    QTr,
    QTd,
    QInput,
    QToggle,
    QPopover,
    QChip,
    QTooltip,
    Collapsible
  },

  props: {
    plural: {
      type: String,
      required: true
    },
    singular: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    tabFilters: {
      type: [Object, Array],
    },
    createRoute: {
      type: String
    },
    rowClick: {
      type: Function
    },
    exportRoute: {
      type: String
    },
    directExportRoute: {
      type: String
    },
    reverseFlowRoute: {
      type: String
    }
  },

  data() {
    return {
      followupStatuses: {},
      tab: '',
      activeToolbar: this.$route.query.search ? 'filter' : '',
      options: {
        plural: this.plural,
        isTrash: false,
        singular: this.singular,
        rowsPerPageOptions: PAGINATION_QUANTITIES,
        columns: this.columns
      },
      isLoading: false,
      pagination: {},
      page: 1,
      filter: '',
      filterTab: 'all',
      colorTabAll: '',
      colorTab: 'secondary',
      tempFilter: '',
      results: {
        meta: {
          total: 0,
          total_unfiltered: 0,
          total_in_trash: 0,
          last_page: 1
        },
        data: [],
        excludeColumns: []
      },
      modalEndDate: false,
      previousEndValue: null,
      end_lending_at: null,
      form: {},
      customDialog: false,
      customDialogMessage: '',
      isMobile: false,
      collapsibleLabel: '',
      collapsibleSubLabel: '',
      selectOpen: false
    }
  },

  methods: {
    async fetchFollowupStatus(orderId) {
      try {
        const response = await axios.get(`${window.config.appUrl}/api/lending-follow-up/${orderId}`);
        console.log(response.data[0].follow_up_status);
        const followupData = response.data[0]; 
        if (followupData.has_follow_up) {
          this.$set(this.followupStatuses, orderId, followupData.follow_up_status);
        } else {
          this.$set(this.followupStatuses, orderId, 'Sin Seguimiento');
        }
      } catch (error) {
        console.error(`Error fetching follow-up status for order ${orderId}:`, error);
      }
    },
    async loadFollowupStatuses() {
      for (const order of this.results.data) {
        await this.fetchFollowupStatus(order.id);
      }
    },
    closeDialog() {
      this.modalEndDate = !this.modalEndDate
    },
    updateFilter: debounce(function () {
      this.filter = this.tempFilter
    }, 500),

    applyFilter(filterName) {
      this.results.data = []
      this.filterTab = filterName
      if (filterName === 'all') {
        this.colorTabAll = 'primary'
      } else {
        this.colorTabAll = 'secondary'
      }
      this.refreshRows('', '', filterName)
    },

    getPaginationFromQuery() {
      if (!this.options) return
      let page = parseInt(getNested('page', this.$route.query, 1))
      this.page = page
      let rowsPerPage = parseInt(getNested('per_page', this.$route.query, PER_PAGE))
      let pagination = {
        page,
        rowsPerPage,
        sortBy: getNested('sort_by', this.$route.query, null), // String, column "name" property value
        descending: getNested('descending', this.$route.query, true).toString() === 'true',
        rowsNumber: this.pagination.rowsNumber || page * rowsPerPage // specifying this determines pagination is server-side
      }
      let filter = getNested('search', this.$route.query, '')

      if (objectToString(pagination) !== objectToString(this.pagination) || this.filter !== filter) {
        this.filter = filter
        this.pagination = pagination
      }
    },

    async refreshRows({pagination, filter, filterTab} = {pagination: null, filter: null, filterTab: null}) {
      if (!pagination) pagination = this.pagination
      if (!filter) filter = this.filter
      if (!filterTab) filterTab = this.filterTab

      let query = { // ETL from component to API
        page: pagination.page,
        sort_by: pagination.sortBy,
        descending: pagination.descending,
        per_page: pagination.rowsPerPage,
        search: filter,
        filterTab: filterTab
      }

      // QTable does not update the pagination and filter models directly
      this.pagination = pagination
      this.tempFilter = this.filter = filter

      if (objectToString(this.$route.query) === '{}' || pagination.page === 0)
        this.$router.replace({query: query})
      else if (objectToString(query) !== objectToString(this.$route.query))
        this.$router[this.infiniteScroll === true ? 'replace' : 'push']({query: query})

      await this.request('get', this.resourcePath, {params: query})
          .then((response) => {
            // we also set (or update) rowsNumber
            this.pagination.rowsNumber = response.meta.total

            // then we update the rows with the fetched ones
            this.results.meta = response.meta
            this.results.links = response.links
            this.results.excludeColumns = response.excludeColumns
            if (response.meta.current_page == 1 || !this.infiniteScroll)
              this.results.data = response.data
            else
              response.data.forEach(r => this.results.data.push(r))
          })
    },

    async pickUpStock(id) {
      await this.request('get', `${this.resourcePath}/pickup/${id}`)
          .then((response) => {
            this.notify(this.$T('success'), response.success.message)
            this.refreshRows()
          })
    },

    /**
     * Submit a request.
     *
     * @param {string} requestType
     * @param {string} url
     */
    request(requestType, url, data = {}) {
      this.isLoading = true

      return new Promise((resolve, reject) => {
        axios[requestType](url, data)
            .then(response => {
              this.onSuccess(response.data);

              resolve(response.data);
            })
            .catch(error => {
              this.onFail(error.response.data);

              reject(error.response.data);
            })
      });
    },

    /**
     * Handle a successful request.
     *
     * @param {object} data
     */
    onSuccess(data) {
      this.isLoading = false
    },

    /**
     * Handle a failed request.
     *
     * @param {object} errors
     */
    onFail(data) {
      this.isLoading = false

      if (data && data.error)
        this.notify(this.$T('error'), data.error.message, [], 'negative')
    },

    notify(message, detail, actions = [], type = 'positive') {
      this.$q.notify({
        type,
        position: 'top',
        message,
        detail,
        timeout: 5000,
        actions
      })
    },

    async init() {
      this.options = {
        plural: this.plural,
        isTrash: false,
        singular: this.singular,
        rowsPerPageOptions: PAGINATION_QUANTITIES,
        columns: this.columns
      }
      this.results.data = []
      this.getPaginationFromQuery()
      const qfilterTab = this.$router.currentRoute.query['filterTab']
      if (qfilterTab && qfilterTab !== 'all') {
        this.filterTab = qfilterTab
        this.applyFilter(qfilterTab)
      } else {
        if (this.$refs['all'] && !this.$refs['all'].active) {
          this.$refs['all'].select()
        }
        await this.refreshRows()
      }
    },

    isActiveToolbar(item) {
      return this.activeToolbar == item
    },

    toggleToolbar(item, event) {
      if (event) event.stopPropagation()
      this.activeToolbar = this.activeToolbar == item ? null : item
    },

    colorFor(status) {

      const orderStatuses = window.config.orderStatuses
      const stockStatuses = window.config.stockStatuses
      let colors = []
      colors[orderStatuses['RESERVED']] = 'primary'
      colors[orderStatuses['PENDING']] = 'primary'
      colors[orderStatuses['IN_LENDING']] = 'info'
      colors[orderStatuses['IN_TRANSIT']] = 'tertiary'
      colors[orderStatuses['CANCELLED']] = 'negative'
      colors[orderStatuses['PENDING_PICKUP']] = 'warning'
      colors[orderStatuses['COMPLETED']] = 'positive'

      colors[stockStatuses['AVAILABLE']] = 'positive'
      colors[stockStatuses['RESERVED']] = 'primary'
      // colors[stockStatuses['TO_CLEAN']] = 'tertiary'
      colors[stockStatuses['BROKEN']] = 'negative'
      // colors[stockStatuses['LOST']] = 'negative'
      colors[stockStatuses['NOT_RETURNED']] = 'warning'
      colors[stockStatuses['IN_LENDING']] = 'info'
      colors[stockStatuses['RETIRED']] = 'tertiary'
      colors[stockStatuses['PENDING_RECEPTION']] = 'warning'
      colors[stockStatuses['NOT_RECEIVED']] = 'negative'
      // colors[stockStatuses['ROBBED']] = 'negative'
      colors[stockStatuses['SOLD']] = 'deep-orange'

      return colors[status]
    },

    openURL,

    isModalOpen(obj) {
      this.$emit('openModalDetail', obj)
    },

    editRow(props, event) {
      event.stopPropagation()
      this.changeEndDate(props.row)
    },

    actionsColumnLabel() {
      if (this.isCurrentRoute('lending-point.orders') ||
          this.isCurrentRoute('sales-expert.orders') ||
          this.isCurrentRoute('call-center.orders')) {
        return this.$T('edit date')
      } else if (this.isCurrentRoute('lending-point.lending-kits.pending-reception') ||
          this.isCurrentRoute('lending-point.orders.in-lending') ||
          this.isCurrentRoute('sales-expert.clear') ||
          this.isCurrentRoute('sales-expert.clear')) {
        return this.$T('action')
      }
      return this.$T('actions')
    },

    highlightRow(props) {
      return (this.isCurrentRoute('lending-point.orders') || this.isCurrentRoute('sales-expert.orders')) &&
          props.row['order_status.description'] === window.config.orderStatuses['IN_LENDING'] &&
          props.row.end_lending_at &&
          moment(props.row.end_lending_at, 'YYYY-MM-DD HH:mm:ss').isBefore(moment().format('YYYY-MM-DD HH:mm:ss'))
    },

    enableEdit(props) {
      return props.row['order_status.description'] === window.config.orderStatuses['IN_LENDING']
          && (this.isCurrentRoute('lending-point.orders')
              || this.isCurrentRoute('sales-expert.orders')
              || this.isCurrentRoute('call-center.orders'))
    },

    orderWarningButton(event) {
      event.stopPropagation()
    },

    changeEndDate(row) {
      this.form = new Form(Object.assign(deepCopy(this.orderModel), row))
      this.minEndLendingAt()
      this.modalEndDate = true
      this.previousEndValue = this.end_lending_at
    },

    cancelEndDate() {
      this.modalEndDate = false
      this.end_lending_at = this.previousEndValue
    },

    async save() {
      await this.form.patch(`${window.config.appUrl}/api/v1/order`)
          .then(({data}) => {
            this.modalEndDate = false
            this.form = {}
            this.refreshRows()
            this.customDialogMessage = data.success.message
            this.customDialog = true
          })
          .catch(response => console.log(response))
    },

    calculateLendingExpiredDays(props) {
      let days = Math.abs(moment(props.row.end_lending_at, 'YYYY-MM-DD HH:mm:ss').diff(moment().format('YYYY-MM-DD HH:mm:ss'), 'days'))
      if (days === 1) {
        return 'hace ' + days + ' día'
      }
      return 'hace ' + days + ' días'
    },

    collapsibleRowEdit(item) {
      this.changeEndDate(item)
    },

    minEndLendingAt() {
      axios.get(`${config.appUrl}/api/v1/lending-point/order/form-mock-data`).then(response => {
        this.form.minimum_lending_at = moment(this.form.start_lending_at)
            .add(response.data.minimumLendingDays, 'days')
            .format('YYYY-MM-DD')
      })
    },

    isCurrentRoute(routeName) {
      return this.$route.name === routeName
    }
  },

  mounted() {
    this.init()
    this.isMobile = this.$q.platform.is.mobile
    this.$root.$on('closeToolbar', (event) => {
      event.stopPropagation()
      if (this.selectOpen) {
        this.selectOpen = false
        return
      }
      this.activeToolbar = null
    })
  },
  created() {
    this.loadFollowupStatuses();
  },
  updated() {
    let classObjArrowLeft = this.$refs['pagination'].$el.children[0].classList
    let classObjArrowRight = this.$refs['pagination'].$el.children[2].classList

    this.$refs['pagination'].$el.children[0].hidden = Object.values(classObjArrowLeft).includes('disabled')
    this.$refs['pagination'].$el.children[2].hidden = Object.values(classObjArrowRight).includes('disabled')
  },

  watch: {
    $route: 'getPaginationFromQuery',
    slug: 'init',
    'page'() {
      const query = {...this.$route.query, page: this.page}
      this.$router.replace({query})
      this.$set(this.pagination, 'page', this.page)
      this.refreshRows()
    },

    results: {
      handler() {
        this.loadFollowupStatuses();
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters({
      notificationEnabled: 'notifications/enabled',
      user: 'auth/user'
    }),

    showTabs() {
      if (this.tabFilters && this.$router.currentRoute.path.includes('lending-kits')) {
        return true
      }
      return this.tabFilters && this.notificationEnabled === '1';
    },

    columnsOptions() {
      return this.options.columns.filter(c => !c.required).map(c => ({value: c.field, label: c.label}))
    },

    visibleColumns: userPreferences('visibleColumns', []),

    baseRoute() {
      return this.slug.split('/').join('-');
    },

    resourcePath() {
      return `${config.appUrl}/api/v1/${this.slug}`
    },

    columnsAvailable() {
      if (this.results.excludeColumns) {
        let cols = this.results.excludeColumns;
        this.options.columns = this.options.columns.filter(item => cols.indexOf(item.name) === -1)
      }

      if (this.options.columns) {
        if (this.actionColumnIsFirst) {
          this.options.columns.unshift(this.actionColumn)
        } else if (this.actionColumnIsLast) {
          this.options.columns.push(this.actionColumn)
        }

        this.options.columns.forEach(column => {
          if (column.hasOwnProperty('collapsibleLabel') && column.collapsibleLabel) {
            this.collapsibleLabel = column.collapsibleLabel
          }
          if (column.hasOwnProperty('collapsibleSubLabel') && column.collapsibleSubLabel) {
            this.collapsibleSubLabel = column.collapsibleSubLabel
          }
        })
      }

      return this.options.columns
    },

    actionColumnIsFirst() {
      return this.actionColumnNotIsFirst && this.routeHasActionInFirstColumn
    },

    actionColumnIsLast() {
      return this.actionColumnNotIsLast && this.routeHasActionInLastColumn
    },

    actionColumnNotIsFirst() {
      return [...this.options.columns].shift().name !== '-actions'
    },

    actionColumnNotIsLast() {
      return [...this.options.columns].pop().name !== '-actions'
    },

    actionColumn() {
      return {
        label: this.actionsColumnLabel(),
        name: '-actions',
        align: 'right',
        required: true
      }
    },

    routeHasActionInFirstColumn() {
      return this.isCurrentRoute('lending-point.lending-kits.pending-reception')
          || this.isCurrentRoute('lending-point.orders.in-lending')
          || this.isCurrentRoute('sales-expert.clear')
          || this.isCurrentRoute('lending-point.clear')
          || this.isCurrentRoute('sales-expert.orders.in-lending')
    },

    routeHasActionInLastColumn() {
      return this.isCurrentRoute('lending-point.orders')
          || this.isCurrentRoute('sales-expert.orders')
          || this.isCurrentRoute('call-center.orders')
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/_list.vue